import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { useSideBar } from "../context/SideBarContext";
import { STORAGE_KEYS } from "../../Util/key_helper";
import { UseProfileContext } from "../context/ProfileContext";
import { PORTAL_LOGO_MINI } from "../../Util/constant";
import ResetpasswordModal from "../components/modal/ResetPasswordModal";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../Util/helper_functions";
const Navbar = () => {
	const { isDarkTheme } = useTheme();
	const { toggleSideBar } = useSideBar();
	const { profileData } = UseProfileContext();
	const navigate = useNavigate();
	const [showResetpasswordModal, setShowResetPasswordModal] = useState(false)

	const toggleOffcanvas = () => {
		document.querySelector(".sidebar-offcanvas").classList.toggle("active");
	};


	return (
		<>
			<nav className="navbar p-0 fixed-top d-flex flex-row">
				<div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
					<Link className="navbar-brand brand-logo-mini" to="/">
						<img
							src={PORTAL_LOGO_MINI}
							alt="logo"
						/>
					</Link>
				</div>
				<div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch justify-content-end">
					<button className="navbar-toggler navbar-toggler align-self-center"
						type="button"
						style={{ border: 'none' }}
						onClick={() => { document.body.classList.toggle("sidebar-icon-only"); toggleSideBar(); }}	>
						<span className="mdi mdi-menu"></span>
					</button>
					<ul className="navbar-nav navbar-nav-right">

						<Dropdown align="end" className="nav-item">
							<Dropdown.Toggle variant="" id="dropdown-basic" className="d-flex text-white align-items-center no-caret no-margin" style={{ background: 'transparent', border: 'none', padding: 0 }}	>
								<h6 className="mb-0 me-1 text-white">{profileData?.email}</h6>
								<i className="mdi mdi-menu-down"></i>
							</Dropdown.Toggle>

							<Dropdown.Menu className={`navbar-dropdown preview-list ${isDarkTheme ? "dark-dropdown-menu" : 'light-dropdown-menu'}`}>
								<Dropdown.Item className="preview-item" onClick={() => setShowResetPasswordModal(true)}>
									<div className="preview-thumbnail p-1">
										<i className="mdi mdi-key text-success mr-0"></i>
									</div>
									<div className="preview-item-content">
										<p className="preview-subject mb-1" style={{ whiteSpace: "pre-wrap" }}>
											Change Password
										</p>
									</div>

								</Dropdown.Item>
								<Dropdown.Divider />
								<Dropdown.Item className="preview-item" onClick={() => logoutUser(navigate)}>
									<div className="preview-thumbnail p-1">
										<i className="mdi mdi-logout text-danger mr-0"></i>
									</div>
									<div className="preview-item-content">
										<p className="preview-subject mb-1" style={{ whiteSpace: "pre-wrap" }}>
											Logout
										</p>
									</div>
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>

					</ul>
					<button
						className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
						type="button"
						onClick={toggleOffcanvas}
					>
						<span className="mdi mdi-format-line-spacing"></span>
					</button>
				</div>
			</nav>
			{showResetpasswordModal && (
				<ResetpasswordModal
					show={showResetpasswordModal}
					onClose={() => setShowResetPasswordModal(false)}
				/>
			)}
		</>
	);
};

export default Navbar;